/*IMPORTS */

/*React & React module dependencies */

/*Custom containers */
import MainMenu from '../../components/MainMenu';
import HomePage from '../HomePage';
import QA from '../QA';
import QAFilterList from '../QA/components/QAFilterList';
import Filinnlesninger from '../QA/Filinnlesninger';
import FilinnlesningerDetaljer from '../QA/Filinnlesninger/Detaljer';
import Mottakere from '../Mottakere';
import AbonnementPage from '../Abonnement';
import Distribusjoner from '../Distribusjoner';
import Importer from '../Importer';
import AlkoholbevillingDashboard from '../Importer/AlkoholbevillingDashboard';
import BulkJobber from '../BulkJobber';

/*Custom contexts */
import ToastProvider from '../../utils/contexts/ToastProvider';
import ThemeProvider from '../../utils/contexts/ThemeProvider';
import Bransjer from 'pages/Bransjer';
import { Route, Routes } from 'react-router-dom';
import EnhetSearch from 'pages/EnhetSearch';
import Enhet from 'pages/Enhet';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import Kjeder from 'pages/Kjeder';
import KjederTilNedleggelse from 'pages/KjederTilNedleggelse';
import Docs from 'pages/Docs';
import Enhetsgruppering from 'pages/Enhetsgruppering';
import Grossister from 'pages/Grossister';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import EnsureAuthToken from 'utils/contexts/EnsureAuthToken';
import Test from 'pages/Test';
import { Row } from 'react-bootstrap';
import SidebarWrapper from 'pages/EnhetSearch/components/Sidebar/SidebarWrapper';
import BrregOppdateringerPage from 'pages/BrregOppdateringer';
import NyeUnderenheterPage from 'pages/NyeUnderenheter';
import NaceEndringerPage from 'pages/NaceEndringer';
import NaceKodeImportPage from 'pages/NaceKodeImport';
import SalgFraTilknyttetGrossistgruppe from 'pages/SalgFraTilknyttetGrossistgruppe';
import DagligvareOmsetningImport from 'pages/DagligvareOmsetningImport';
import InnkjopSync from 'pages/InnkjopSync';
import EnrichmentDashboard from 'pages/EnrichmentDashboard';

/*IMPORTS END */

const App = () => {
  // redirect to login if not authenticated
  useMsalAuthentication(InteractionType.Redirect);

  /*Content */
  return (
    <div>
      <AuthenticatedTemplate>
        <EnsureAuthToken>
          <ThemeProvider>
            <ToastProvider>
              <MainMenu />
              <div className="container-fluid">
                <Row className="flex-nowrap">
                  <SidebarWrapper />
                  <main className="col">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/enheter" element={<EnhetSearch />} />
                      <Route path="/enheter/:id" element={<Enhet />} />
                      <Route path="/qa" element={<QA />} />
                      <Route path="/qa/filter" element={<QAFilterList />} />
                      <Route path="/qa/filinnlesninger" element={<Filinnlesninger />} />
                      <Route path="/qa/filinnlesninger/:id" element={<FilinnlesningerDetaljer />} />
                      <Route path="/bransjer" element={<Bransjer />} />
                      <Route path="/mottakere" element={<Mottakere />} />
                      <Route path="/kjeder" element={<Kjeder />} />
                      <Route path="/kjeder-til-nedleggelse" element={<KjederTilNedleggelse />} />
                      <Route path="/docs" element={<Docs />} />
                      <Route path="/docs/:slug" element={<Docs />} />
                      <Route path="/grossister" element={<Grossister />} />
                      <Route path="/enhetsgruppering" element={<Enhetsgruppering />} />
                      <Route path="/abonnement" element={<AbonnementPage />} />
                      <Route path="/distribusjoner" element={<Distribusjoner />} />
                      <Route path="/importer" element={<Importer />} />
                      <Route
                        path="/importer/alkoholbevillinger"
                        element={<AlkoholbevillingDashboard />}
                      />
                      <Route path="/bulkjobber" element={<BulkJobber />} />
                      <Route path="/test" element={<Test />} />
                      <Route path="/brreg-oppdateringer" element={<BrregOppdateringerPage />} />
                      <Route path="/nye-underenheter" element={<NyeUnderenheterPage />} />
                      <Route path="/nace-endringer" element={<NaceEndringerPage />} />
                      <Route path="/nace-kode-import" element={<NaceKodeImportPage />} />
                      <Route
                        path="/innkjop-grossister"
                        element={<SalgFraTilknyttetGrossistgruppe />}
                      />
                      <Route path="/dagligvare-omsetning" element={<DagligvareOmsetningImport />} />
                      <Route path="/innkjop-sync" element={<InnkjopSync />} />
                      <Route path="/enrichment-dashboard" element={<EnrichmentDashboard />} />
                    </Routes>
                  </main>
                </Row>
              </div>
            </ToastProvider>
          </ThemeProvider>
        </EnsureAuthToken>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <p>Redirecting to login...</p>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default App;
